import {createModel} from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import type {LearningTaskModel} from "~~/package/mapper/learning/model/LearningTaskModel";

export class ProSkillAssureAssessmentSetModel extends Model {
    constructor(
        public index: number = 0,
        public templateId: number = 0,
        public trackTitle: string = "",
        public trackLevelTitle: string = "",
        public taskList: LearningTaskModel[] = []
    ) {
        super();
    }

    public static create(model: Partial<ProSkillAssureAssessmentSetModel>): ProSkillAssureAssessmentSetModel {
        return createModel<ProSkillAssureAssessmentSetModel>(ProSkillAssureAssessmentSetModel, {
            ...model
        });
    }
}
